import { render, staticRenderFns } from "./HomeAvgSessions.vue?vue&type=template&id=68c05718&"
import script from "./HomeAvgSessions.vue?vue&type=script&lang=js&"
export * from "./HomeAvgSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports